import { ReportData } from '@/components/preview/types';
import { createPageUrl } from './createPageUrl';
import { ReportPage } from '@/pages/constants';

export const getReportLink = (report_id?: ReportData['id']) => {
    const fullURL = report_id ? `${ReportPage}?id=${report_id}` : ReportPage;

    return createPageUrl(fullURL);
};
